class StickyScrollCarousel extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.latestScrollY = 0
    this.currentStickyTop = null
    this.trackWidth = 0
    this.isTicking = false

    this.touchStartX = 0
    this.touchStartY = 0
    this.touching = false
    this.horizontalScrollEnabled = true
    this.touchThreshold = 10

    this.handleScrollEvent = this.handleScrollEvent.bind(this)
    this.updateScrollContainerHeight = this.updateScrollContainerHeight.bind(
      this,
    )
    this.update = this.update.bind(this)

    this.handleTouchStart = this.handleTouchStart.bind(this)
    this.handleTouchMove = this.handleTouchMove.bind(this)
    this.handleTouchEnd = this.handleTouchEnd.bind(this)

    this.initialize()
  }

  initialize () {
    if (!this.els?.track?.exists || window.innerWidth > 768) return

    this.updateTrackWidth()
    this.updateScrollContainerHeight()
    this.updateStickyCarousel()
    this.update()
  }

  setupListeners () {
    super.setupListeners()

    // this.listeners.add(window, 'resize', this.updateTrackWidth.bind(this))
    // this.listeners.add(
    //   window,
    //   'resize',
    //   this.updateScrollContainerHeight.bind(this),
    // )
    // this.listeners.add(window, 'resize', this.update.bind(this))
    this.listeners.add(window, 'scroll', this.handleScrollEvent.bind(this), {
      passive: true,
    })

    const track = this.els.track.element
    this.listeners.add(track, 'touchstart', this.handleTouchStart.bind(this), {
      passive: true,
    })
    this.listeners.add(track, 'touchmove', this.handleTouchMove.bind(this), {
      passive: false,
    })
    this.listeners.add(track, 'touchend', this.handleTouchEnd.bind(this), {
      passive: true,
    })
  }

  handleTouchStart (e) {
    if (!this.horizontalScrollEnabled) return
    const touch = e.touches[0]
    this.touchStartX = touch.clientX
    this.touchStartY = touch.clientY
    this.touching = true
  }

  handleTouchMove (e) {
    if (!this.touching) return

    const touch = e.touches[0]
    const deltaX = touch.clientX - this.touchStartX
    const deltaY = touch.clientY - this.touchStartY

    if (
      Math.abs(deltaX) > Math.abs(deltaY) &&
      Math.abs(deltaX) > this.touchThreshold
    ) {
      e.preventDefault() // prevent native vertical scroll during horizontal swipe

      const scrollFactor = 1.3 // Adjust scroll sensitivity
      const newScrollY = window.scrollY - deltaX * scrollFactor

      const container = this.els?.container?.element
      if (container) {
        const containerRect = container.getBoundingClientRect()
        const containerTop = containerRect.top + window.scrollY
        const containerBottom =
          containerTop + container.offsetHeight - window.innerHeight

        const clampedScrollY = Math.max(
          Math.min(newScrollY, containerBottom),
          containerTop,
        )

        window.scrollTo({ top: clampedScrollY, behavior: 'smooth' })
      }
    }
  }

  handleTouchEnd () {
    this.touching = false
  }

  updateScrollContainerHeight () {
    if (!this.els?.track?.exists || window.innerWidth > 768) return

    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight

    const containerHeight =
      this.els?.track.element.scrollWidth - viewportWidth + viewportHeight

    if (this.els?.container?.element) {
      this.els.container.element.style.height = `${containerHeight}px`
    }
  }

  handleScrollEvent () {
    this.latestScrollY = window.scrollY

    if (!this.isTicking) {
      requestAnimationFrame(this.update)
      this.isTicking = true
    }
  }

  updateTrackWidth () {
    const track = this.els?.track?.element
    const wrapper = this.els?.wrapper?.element
    if (!track || !wrapper) return

    this.trackWidth = track.scrollWidth - wrapper.offsetWidth
  }

  getScrollProgress (scrollY, containerTop, containerHeight) {
    let progress =
      (scrollY - containerTop) / (containerHeight - window.innerHeight)
    progress = Math.min(Math.max(progress, 0), 1)

    if (scrollY <= containerTop) progress = 0
    if (scrollY >= containerTop + containerHeight - window.innerHeight) {
      progress = 1
    }

    return progress
  }

  updateHorizontalScroll (progress) {
    if (!this.els?.track?.element) return

    const translateX = -progress * this.trackWidth
    this.els.track.element.style.setProperty(
      '--Scroll_Amount',
      `${translateX}px`,
    )
    this.els.track.element._lastTranslateX = translateX
  }

  updateProgressBar (progress) {
    const progressBar = this.els?.progressBar?.element
    if (!progressBar) return

    progressBar.style.setProperty('--progress', progress)
    progressBar._lastProgress = progress
  }

  updateStickyCarousel () {
    const wrapper = this.els?.wrapper?.element
    if (!wrapper) return

    const renderedHeaderHeight = this.els?.stickyHeader?.element.offsetHeight || 0
    const renderedTrackHeight = this.els?.track?.element.offsetHeight || 0

    const marginSpacing = 64;

    wrapper.style.height = `${renderedTrackHeight + renderedHeaderHeight + marginSpacing}px`
    wrapper.style.top = `calc(100vh - ${renderedTrackHeight + renderedHeaderHeight + marginSpacing}px)`
  }

  setStickyHeaderStyles (element, styles) {
    Object.assign(element.style, styles)
  }

  update () {
    const scrollY = this.latestScrollY
    const container = this.els?.container?.element
    const stickyHeader = this.els?.stickyHeader?.element
    if (!container || !stickyHeader) return

    const headerHeight = stickyHeader.offsetHeight
    const containerRect = container.getBoundingClientRect()
    const containerTop = containerRect.top + window.scrollY
    const containerHeight = container.offsetHeight

    const progress = this.getScrollProgress(
      scrollY,
      containerTop,
      containerHeight,
    )

    this.updateHorizontalScroll(progress)
    this.updateProgressBar(progress)

    this.isTicking = false
  }
}

if (!customElements.get('sticky-scroll-carousel')) {
  customElements.define('sticky-scroll-carousel', StickyScrollCarousel)
}
